import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * MatIconRegistry is a service to register and display icons used by the <mat-icon> component.
 *
 * Registers icon URLs by namespace and name.
 * Registers icon set URLs by namespace.
 * Registers aliases for CSS classes, for use with icon fonts.
 * Loads icons from URLs and extracts individual icons from icon sets.
 *
 * NOTE: Always download icons from the link below.
 * @link https://fontawesome.com/icons
 */

export const initMatIconRegistryFactory = (matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) => {
	return () => {
		// Add here all custom SVG icon that needs to be registered.
		const SVG_ICONS = ['whatsapp', 'whatsapp-2', 'phone', 'viber', 'exclamation-warning', 'rocket', 'phone-missed', 'bell-icon'];

		// Regiter the SVG icon using `matIconRegistry`
		SVG_ICONS.forEach((icon) => {
			matIconRegistry.addSvgIcon(icon, domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`));
		});
	};
};
